// Unit conversion helpers. DB always stores metric (cm, kg).
// Display layer can render in imperial (in/ft, lb) per user preference.

export const KG_PER_LB = 0.45359237;
export const CM_PER_IN = 2.54;

export const kgToLb = (kg) => (kg == null ? null : kg / KG_PER_LB);
export const lbToKg = (lb) => (lb == null ? null : lb * KG_PER_LB);
export const cmToIn = (cm) => (cm == null ? null : cm / CM_PER_IN);
export const inToCm = (i) => (i == null ? null : i * CM_PER_IN);

// Decompose total inches into {ft, in}
export const inToFtIn = (totalIn) => {
  if (totalIn == null) return { ft: 0, in: 0 };
  const ft = Math.floor(totalIn / 12);
  const inch = Math.round((totalIn - ft * 12) * 10) / 10;
  return { ft, in: inch };
};
export const ftInToCm = (ft, inch) => inToCm((Number(ft) || 0) * 12 + (Number(inch) || 0));

export const formatWeight = (kg, units) => {
  if (kg == null) return "—";
  if (units === "imperial") return `${kgToLb(kg).toFixed(1)} lb`;
  return `${Number(kg).toFixed(1)} kg`;
};

export const formatHeight = (cm, units) => {
  if (cm == null) return "—";
  if (units === "imperial") {
    const { ft, in: inch } = inToFtIn(cmToIn(cm));
    return `${ft}'${Math.round(inch)}"`;
  }
  return `${Math.round(cm)} cm`;
};
